import React from 'react';
import { Container, Form, InputGroup, Label, Row } from 'reactstrap';
import { Field } from 'redux-form';
import cx from 'classnames';

// components
import FirmTypeAhead from '../../../components/form/field/firm-typeahead';

// modules
import BS from '../../../theme/Bootstrap';
import styles from '../../Containers.module.scss';

const BrokerageSearch = props => {
  const { handleSubmit } = props;
  return (
    <Row className={cx(styles.searchHeader, BS.pt3)}>
      <Container>
        <Form inline className={cx(BS.alignItemsStart)} onSubmit={handleSubmit}>
          {props.children}
          <InputGroup className={cx(BS.inputGroupGutter, BS.pb2)}>
            <Label for="name" className="sr-only">
              Name
            </Label>
            <Field
              name="name"
              type="text"
              placeholder="Name"
              component={FirmTypeAhead}
              officeType="brokerage"
              showSubmit
              submitClassName={cx(BS.ml2)}
            />
          </InputGroup>
        </Form>
      </Container>
    </Row>
  );
};

export default BrokerageSearch;



// WEBPACK FOOTER //
// ./src/containers/OfficeSearch/Search/BrokerageSearch.js